import type { CaptureDeps } from './capture/core';
import {
  SpeechHttpError,
  type CaptureHandle,
  type CaptureOptions,
  type SpeechConfig,
} from './contracts';
import { parseSpeechUnavailableReason } from './transport/http';

export type ScopedCaptureStart = (options: CaptureOptions) => Promise<CaptureHandle>;

/** Re-checks the authenticated company policy immediately before touching a microphone. */
export function guardCaptureStart(
  load: () => Promise<SpeechConfig>,
  scope: () => string,
  start: (options: CaptureOptions, deps?: CaptureDeps) => Promise<CaptureHandle>,
): ScopedCaptureStart {
  return (options) => {
    const requestedScope = scope();
    const authorize = async () => {
      const config = await load();
      if (requestedScope !== scope())
        throw new SpeechHttpError(503, 'speech_unavailable', null, 'processing_policy_unavailable');
      const availability = options.purpose === 'voice' ? config?.voice : config;
      if (availability?.available !== true)
        throw new SpeechHttpError(
          503,
          'speech_unavailable',
          null,
          parseSpeechUnavailableReason(availability?.reason) ?? 'provider_unavailable',
        );
    };
    return start(options, { beforeOpen: authorize });
  };
}
